import makeApi from "../../libs/axios/api";
import { TransportKeyDetails, TransportKeyPayload } from "../../types/transportkey";
const apiPromise = makeApi();


const getTansportKey = async (
    request: TransportKeyPayload
  ): Promise<TransportKeyDetails> => {
    const api = await apiPromise;
    const storedData = localStorage.getItem("customerInfo");
    const userInfo = storedData ? JSON.parse(storedData) : {};
    const username = userInfo.userName;
    const userId = userInfo.userID;
    const path = `/b2buser/transportkey?username=${username}&userId=${userId}&applicationId=${request.applicationId}`;
    return api.get(path).then((response) => {
      return response.data as TransportKeyDetails;
    });
  };
  export default getTansportKey;
  